import clsx from 'clsx';
import type { KeyboardEvent, MouseEvent, ReactElement, RefObject } from 'react';

import { SDSIcon, type SDSIconColor, type SDSIconSize } from '@repo/sds/components/SDSIcon';
import { SDSPrimitiveButton } from '@repo/sds/components/SDSPrimitiveButton';

import './SDSIconButton.scss';

export interface SDSIconButtonProps {
  icon: ReactElement;
  ariaLabel: string;
  size?: SDSIconSize;
  color?: SDSIconColor;
  onClick?: (event: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => void;
  href?: string;
  isDisabled?: boolean;
  className?: string;
  dataTestId?: string;
  ariaPressed?: boolean;
  buttonRef?: RefObject<HTMLButtonElement | null>;
}

export function SDSIconButton({
  icon,
  ariaLabel,
  size = 'medium',
  color,
  onClick,
  href,
  isDisabled,
  className,
  dataTestId,
  ariaPressed,
  buttonRef,
}: SDSIconButtonProps) {
  return (
    <SDSPrimitiveButton
      className={clsx('SDSIconButton', className)}
      onClick={onClick}
      href={href}
      isDisabled={isDisabled}
      ariaLabel={ariaLabel}
      dataTestId={dataTestId}
      ariaPressed={ariaPressed}
      buttonRef={buttonRef}
    >
      <SDSIcon icon={icon} size={size} color={color} />
    </SDSPrimitiveButton>
  );
}
